export default __webpack_public_path__ + "static/media/mx.479622e6.svg";